import { Component, OnInit } from '@angular/core';
import { MsalService } from '../../_shared/services/msal.service';
import { MonitoringService } from '../../_shared/services/monitoring.service';
 
@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
 
  isAuthenticated = false;
 
  constructor(
      private msalSvc: MsalService,
      monitoringService: MonitoringService) {
      monitoringService.logPageView();
      this.isAuthenticated = this.msalSvc.authenticated;
  }
 
  ngOnInit() {
    if (this.isAuthenticated) {
        this.msalSvc.logout();
    }
  }
}


// WEBPACK FOOTER //
// ./ClientApp/app/pages/logout/logout.component.ts